<template>
  <div>
    <div class="order-solution">
      <div class="os-list">
        <div class="os-title">
          <el-row :gutter="24">
            <el-col :span="12">
              <div class="left flex-between">
                <div
                  class="title-control flex-between"
                  @click="showHandleData = !showHandleData"
                >
                  <i class="el-icon-arrow-up" v-if="!showHandleData"></i>
                  <i class="el-icon-arrow-down" v-else></i>
                </div>
                <p class="title">
                  {{ $lange == "en" ? "Spare Part Order" : "配件订单" }}({{
                    orderData.countPartsOrder
                  }})
                </p>
                <span></span>
              </div>
            </el-col>
          </el-row>
        </div>
        <el-collapse-transition>
          <div class="wrap" v-if="showHandleData">
            <div class="card">
              <div class="add_title">
                <div>
                  <!-- <span class="title">新建配件订单</span> -->
                  <el-button
                    style="min-width: 150px"
                    size="mini"
                    icon="el-icon-plus"
                    @click="openAddPartsFlag"
                    v-if="isHandleV2"
                    >{{
                      $lange == "en" ? "New spare part order" : "添加配件"
                    }}</el-button
                  >
                </div>
                <div
                  :class="
                    'user_select ' + ($lange == 'en' ? 'user_select2' : '')
                  "
                  v-if="isHandleV2"
                >
                  <span>{{
                    $lange == "en" ? "Responsible:" : "处理人："
                  }}</span>
                  <el-select
                    v-model="fromData.handlerId"
                    placeholder=""
                    size="mini"
                    style="width: 100%"
                  >
                    <el-option
                      v-for="item in userSelectorList"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                    >
                    </el-option>
                  </el-select>
                </div>
              </div>

              <div class="new_wrap">
                <div class="new_wrap_left">
                  <div class="table">
                    <cc-table
                      :config="addTable"
                      :data-arr="holdList"
                      :load-data="false"
                    ></cc-table>
                  </div>
                </div>
                <div class="new_wrap_right" v-if="isHandleV2">
                  <div class="new_wrap_right_button">
                    <el-button
                      size="mini"
                      type="primary"
                      style="width: 100%"
                      @click="save(1)"
                      >{{ $lange == "en" ? "Submit" : "提交" }}</el-button
                    >
                  </div>
                  <div class="new_wrap_right_button">
                    <el-button
                      size="mini"
                      style="width: 100%"
                      @click="saveHold(0)"
                      >{{
                        $lange == "en" ? "Save as a draft" : "保存草稿"
                      }}</el-button
                    >
                  </div>
                  <div class="new_wrap_right_button">
                    <el-button
                      size="mini"
                      style="width: 100%"
                      @click="openUploaderDialog = true"
                      >{{
                        $lange == "en" ? "Attachment" : "上传附件"
                      }}</el-button
                    >
                    <!-- <div class="uploaderConf2">
                      <cc-uploader
                        :config="uploaderConf2"
                        uploadType="dottedLine"
                        @upload-success="uploadTrue"
                        :isMultiple="true"
                      />
                    </div> -->
                  </div>
                </div>
              </div>
              <div class="file">
                <div>
                  <span>{{ $lange == "en" ? "Attachment" : "附件" }}：</span>
                </div>
                <div class="file_img">
                  <div v-if="fromData.accessoryInfoList.length == 0">
                    {{ $lange == "en" ? "Null" : "无" }}
                  </div>
                  <div
                    class="img_list"
                    v-for="(img, index) in fromData.accessoryInfoList"
                  >
                    <el-image
                      :key="index"
                      class="img"
                      :src="img.accessoryUrl"
                      fit="fit"
                      @click="showImage(img.accessoryUrl)"
                    >
                      <div slot="error" class="image-slot">
                        <i class="el-icon-picture-outline"></i></div
                    ></el-image>
                    <div
                      class="del-image flex-between"
                      @click.stop="deleteImage(index)"
                    >
                      X
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="order_mountings_list_wrap">
              <div class="order_mountings_list_card">
                <cc-table
                  :title="
                    $lange == 'en' ? 'Existing Spare Part Order' : '已有申请'
                  "
                  :config="listTableConfig"
                  :refesh-params="listTablereferTableConfig"
                ></cc-table>
              </div>
            </div>
          </div>
        </el-collapse-transition>
      </div>
    </div>
    <el-dialog :visible.sync="showImageFlag" width="80%" append-to-body>
      <img
        :src="nowShowImageUrl"
        style="display: block; margin: 0 auto; width: 100%"
        alt
      />
    </el-dialog>
    <el-dialog
      :title="$lange == 'en' ? title1[0] : title1[1]"
      :visible.sync="addPartsFlag"
      width="80%"
      class="partsForm"
      append-to-body
    >
      <div
        class="flex-between params-input"
        style="justify-content: flex-start; margin-bottom: 20px"
      >
        <el-input
          v-model="addPartsTableParams.fiCode"
          size="mini"
          :placeholder="
            $lange == 'en' ? 'Please enter FI Code' : '请输入 FI Code'
          "
          style="max-width: 200px; margin-right: 20px"
        >
          <i slot="prefix" class="el-input__icon el-icon-search"></i>
        </el-input>
        <el-input
          v-model="addPartsTableParams.fasCode"
          size="mini"
          :placeholder="
            $lange == 'en' ? 'Please enter Fas Code' : '请输入 Fas Code'
          "
          style="max-width: 200px; margin-right: 20px"
        >
          <i slot="prefix" class="el-input__icon el-icon-search"></i>
        </el-input>
        <el-input
          v-model="addPartsTableParams.partsName"
          size="mini"
          :placeholder="
            $lange == 'en' ? 'Please enter Keyword' : '请输入关键字'
          "
          style="max-width: 200px; margin-right: 20px"
        >
          <i slot="prefix" class="el-input__icon el-icon-search"></i>
        </el-input>
        <el-button
          size="mini"
          icon="el-icon-plus"
          @click="openNewHoldListDialog"
          >{{ $lange == "en" ? "New code" : "添加新料号" }}</el-button
        >
      </div>
      <template v-if="addPartsFlag">
        <cc-table
          :config="addPartsTableConfig"
          :params="addPartsTableParams"
        ></cc-table>
      </template>
    </el-dialog>

    <el-dialog
      :title="$lange == 'en' ? title1[0] : title1[1]"
      :visible.sync="editHoldListDialog"
      width="80%"
      class="partsForm"
      append-to-body
    >
      <cc-form
        :config="formConfig"
        v-model="editorData"
        ref="editForm"
        :rules="rules"
        labelWidth="100px"
      >
      </cc-form>
      <el-button type="primary" size="mini" @click="editorDataSave"
        >保存</el-button
      >
    </el-dialog>

    <el-dialog
      :title="$lange == 'en' ? title2[0] : title2[1]"
      :visible.sync="newHoldListDialog"
      width="50%"
      class="partsForm"
      append-to-body
    >
      <cc-form
        :config="newFormConfig"
        v-model="newFormData"
        ref="newFormData"
        :rules="rules"
        labelWidth="100px"
      >
      </cc-form>
      <el-button type="primary" size="mini" @click="newFormDataSave"
        >保存</el-button
      >
    </el-dialog>
    <el-dialog
      :title="$lange == 'en' ? 'Upload attachments' : '上传附件'"
      :visible.sync="openUploaderDialog"
      width="30%"
      append-to-body
    >
      <template v-if="openUploaderDialog">
        <div class="uploader">
          <cc-uploader
            :config="uploaderConf2"
            uploadType="dottedMultiple"
            @upload-success="uploadTrue"
            :isMultiple="false"
          />
        </div>
      </template>
    </el-dialog>
  </div>
</template>
<script>
import moment from "moment";
export default {
  props: {
    orderData: Object,
    isHandleV2: Boolean,
  },

  data() {
    return {
      title1: [],
      title2: [],
      userSelectorList: [],
      showHandleData: true,
      showImageFlag: false,
      nowShowImageUrl: "",
      addTable: {
        columns: [
          {
            prop: "parts.fasCode",
            lable: this.$lange == "en" ? "FAS Code" : "FAS料号",
            minWidth: 80,
          },
          {
            prop: "parts.partsName",
            lable: this.$lange == "en" ? "Description" : "物料名称",
            minWidth: 100,
          },
          {
            prop: "wareAddress",
            lable: this.$lange == "en" ? "Warehouse" : "仓库",
            minWidth: 80,
            render: (row) => {
              let text = {
                fsWarehouse: "佛山",
                tjWarehouse: "天津",
                shWarehouse: "上海",
                consignmentSale: "寄售",
                cdWarehouse: "成都",
              };
              return text[row.wareAddress];
            },
          },
          {
            prop: "partsNum",
            lable: this.$lange == "en" ? "Quantity" : "需求数量",
            minWidth: 80,
          },
          {
            prop: "feeType",
            lable: this.$lange == "en" ? "Cost Type" : "费用类型",
            minWidth: 100,
            // render: (row) => {
            //   return ["保内", "保外"][row.feeType];
            // },
            type: "tag",
            options: [
              {
                tagType: "info",
                text: this.$lange == "en" ? "Free" : "保内",
              },
              {
                tagType: "warning",
                text: this.$lange == "en" ? "Paid" : "保外",
              },
            ],
            minWidth: 80,
          },
          {
            prop: "parts.fiCode",
            lable: "FI Code",
            minWidth: 80,
          },
          {
            prop: "parts.remark",
            lable: this.$lange == "en" ? "Remark" : "备注",
            minWidth: 150,
          },
        ],
        buttonsLabel: this.$lange == "en" ? "Edit" : "操作",
        buttons: [
          {
            name: this.$lange == "en" ? "Delete" : "移除",
            click: (row, $index) => {
              this.$confirm("此操作会移除该配件", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
              })
                .then(() => {
                  this.holdList.splice($index, 1);
                })
                .catch(() => {});
            },
            check: (row) => {
              return this.isHandleV2;
            },
          },
          {
            name: this.$lange == "en" ? "Edit" : "修改",
            click: (row, $index) => {
              console.log(row);
              //
              this.editorData = { ...row };
              this.editorIndex = $index;
              this.editorData.partsName = row.parts.partsName;
              this.newFormData = { ...this.editorData };
              if (row.parts.id) {
                this.setWareAddressNum(row.parts)
                this.editHoldListDialog = true;
                this.title1 = ["Edit accessories", "修改配件"];
              } else {
                this.newHoldListDialog = true;
                this.newFormData.fasCode = row.parts.fasCode;
                this.newFormData.fiCode = row.parts.fiCode;
                this.title2 = ["Edit accessories", "修改配件"];
              }
            },
            check: (row) => {
              return this.isHandleV2;
            },
          },
        ],
      },
      listTableConfig: {
        api:
          "admin/fsb/parts/order/queryByParts?workOrderId=" + this.orderData.id,
        showPager: true,
        columns: [
          {
            prop: "partsOrder.id",
            lable: this.$lange == "en" ? "Order No." : "订单号",
            minWidth: 90,
          },
          // {
          //   prop: "partsOrder.status",
          //   lable: "订单状态",
          //   minWidth: 100,
          //   render: (e) => {
          //     let type = [
          //       {
          //         label: "草稿",
          //         value: 0,
          //       },
          //       {
          //         label: "新申请",
          //         value: 1,
          //       },
          //       {
          //         label: "待客户确认",
          //         value: 2,
          //       },
          //       {
          //         label: "待审核",
          //         value: 3,
          //       },
          //       {
          //         label: "备料中",
          //         value: 4,
          //       },
          //       {
          //         label: "部分发货",
          //         value: 5,
          //       },
          //       {
          //         label: "已发货",
          //         value: 6,
          //       },
          //       {
          //         label: "已关闭",
          //         value: 7,
          //       },
          //       {
          //         label: "已取消",
          //         value: 8,
          //       },
          //     ];
          //     return type[e.partsOrder.status].label;
          //   },
          // },
          // {
          //   prop: "jobId",
          //   lable: "Job ID",
          //   minWidth: 100,
          // },
          {
            prop: "parts.fasCode",
            lable: this.$lange == "en" ? "FAS Code" : "FAS料号",
            minWidth: 90,
          },
          {
            prop: "parts.partsName",
            lable: this.$lange == "en" ? "Name" : "物料名称",
            minWidth: 150,
          },
          // {
          //   prop: "wareAddress",
          //   lable: "仓库",
          //   minWidth: 80,
          //   render: (row) => {
          //     let text = {
          //       fsWarehouse: "佛山",
          //       tjWarehouse: "天津",
          //       shWarehouse: "上海",
          //       consignmentSale: "寄售",
          //     };
          //     return text[row.wareAddress];
          //   },
          // },
          {
            prop: "partsNum",
            lable: this.$lange == "en" ? "Quantity" : "数量",
            minWidth: 50,
          },
          {
            prop: "feeType",
            lable: this.$lange == "en" ? "Cost Type" : "费用类型",
            minWidth: 70,
            type: "tag",
            options: [
              {
                tagType: "info",
                text: "保内",
              },
              {
                tagType: "warning",
                text: "保外",
              },
            ],
          },
          {
            prop: "status",
            lable: this.$lange == "en" ? "Delivery" : "配送状态",
            minWidth: 80,
            type: "tag",
            options: [
              {
                tagType: "info",
                // text: this.$lange == "en" ? "New" : "备料中",
                text: this.$lange == "en" ? "New" : "未发货",
              },
              {
                tagType: "warning",
                text: this.$lange == "en" ? "Processing" : "部分发货",
              },
              {
                tagType: "success",
                text: this.$lange == "en" ? "Completed" : "已发货",
              },
            ],
          },
          {
            prop: "partsOrder.handlerName",
            lable: this.$lange == "en" ? "Responsible" : "处理人",
            minWidth: 100,
          },
          {
            prop: "planDeliverTime",
            lable: this.$lange == "en" ? "Plan to Ship" : "计划发货",
            minWidth: 100,
            render: (row) => {
              if (row.planDeliverTime) {
                return moment(row.planDeliverTime).format("YYYY-MM-DD");
              }
            },
          },
          {
            prop: "relDeliverTime",
            lable: this.$lange == "en" ? "Ship on" : "实际发货",
            minWidth: 100,
            render: (row) => {
              if (row.relDeliverTime) {
                return moment(row.relDeliverTime).format("YYYY-MM-DD");
              }
            },
          },
          // {
          //   prop: "partsOrder.workOrder.customer.customerName",
          //   lable: this.$lange == "en"?'Company':"公司",
          //   minWidth: 100,
          // },
          // {
          //   prop: "partsOrder.adminName",
          //   lable: "申请人",
          //   minWidth: 100,
          // },
          {
            prop: "partsOrder.createTime",
            lable: this.$lange == "en" ? "Create at" : "创建时间",
            minWidth: 140,
          },
        ],
        buttonsLabel: this.$lange == "en" ? "Edit" : "操作",
        buttons: [
          {
            name: this.$lange == "en" ? "View" : "查看",
            click: (row, $index) => {
              // if (this.isHandleV2) {
              //   this.newWindow({
              //     url:
              //       "/admin/order/list/parts/des?id=" +
              //       row.partsOrderId +
              //       "&isHandle=" +
              //       this.isHandleV2,
              //     name: "配件订单详情",
              //   });
              // } else {
              this.newWindow({
                url: "/admin/order/list/parts/des?id=" + row.partsOrderId,
                name: "配件订单详情",
              });
              // }
            },
            // check:(row) => {
            //   return this.isHandleV2
            // }
          },
        ],
      },
      listTablereferTableConfig: -1,
      options: [],
      addPartsFlag: false,
      addPartsTableParams: {
        fiCode: "",
        fasCode: "",
        partsName: "",
      },
      addPartsTableConfig: {
        api: "admin/fsb/parts/query",
        showPager: true,
        pageSize: 10,
        columns: [
          {
            prop: "fasCode",
            lable: "FAS Code",
            type: "input",
            minWidth: 100,
          },
          {
            prop: "fiCode",
            lable: "FI Code",
            type: "input",
            minWidth: 100,
          },
          {
            prop: "imageUrl",
            lable: this.$lange == "en" ? "Image" : "图片",
            type: "img",
            urlPropName: "imageUrl",
            editAble: true,
            required: true,
            w: 30,
            h: 30,
            info: "建议图片尺寸79*79",
            sourceUrlPropName: "imageUrl",
            imgCompressParams: "?x-oss-process=image/resize,w_50",
          },
          {
            prop: "partsName",
            lable: this.$lange == "en" ? "Accessories name" : "配件名称",
            type: "input",
            minWidth: 150,
          },
          {
            prop: "partsDescription",
            lable: this.$lange == "en" ? "Equipment" : "适用设备",
            type: "input",
            minWidth: 100,
          },
          {
            prop: "warehouseNum",
            lable: this.$lange == "en" ? "Total inventory" : "库存总数",
            type: "input",
          },
          {
            prop: "fsWarehouse",
            lable: this.$lange == "en" ? "FoShan" : "佛山",
            type: "input",
          },
          {
            prop: "shWarehouse",
            lable: this.$lange == "en" ? "ShangHai" : "上海",
          },
          {
            prop: "tjWarehouse",
            lable: this.$lange == "en" ? "TianJin" : "天津",
          },
          {
            prop: "cdWarehouse",
            lable: this.$lange == "en" ? "ChenDu" : "成都",
          },
          {
            prop: "consignmentSale",
            lable: this.$lange == "en" ? "Consignment" : "寄售",
          },
          {
            prop: "salePrice",
            lable: this.$lange == "en" ? "Sale Price" : "价格",
            render: (row) => {
              return (row.salePrice / 100).toFixed(2);
              //   return Math.ceil(row.salePrice / 100).toFixed(1);
            },
          },
          {
            prop: "price",
            lable: this.$lange == "en" ? "Cost" : "成本",
            render: (row) => {
              //   return Math.ceil(row.price / 100);
              return (row.price / 100).toFixed(2);
            },
          },
          {
            prop: "contactName",
            lable: this.$lange == "en" ? "Cumulative shipment" : "累计出货",
          },
          {
            prop: "updateTime",
            lable: this.$lange == "en" ? "Update time" : "更新时间",
            minWidth: 160,
          },
          {
            prop: "remark",
            lable: this.$lange == "en" ? "Remark" : "备注",
            type: "input",
            minWidth: 160,
          },
        ],
        buttonsLabel: this.$lange == "en" ? "Operation" : "操作",
        buttons: [
          {
            name: this.$lange == "en" ? "Add" : "添加",
            click: (row) => {
              let data = {
                partsId: row.id,
                feeType: 0,
                partsNum: 1,
                jobId: this.orderData.jobId,
                parts: {
                  ...row,
                },
                partsName: row.partsName,
                wareAddress: "",
                relPrice: "",
                discount: "",
                salePrice: row.salePrice,
              };
              this.setWareAddressNum(row);
              this.editorData = { ...data };
              this.addPartsFlag = false;
              this.editHoldListDialog = true;
              this.title1 = ["Spare Part List", "添加配件"];
              this.title2 = ["Spare Part List", "添加配件"];
              console.log(data);
            },
          },
        ],
      },
      holdList: [], //暂存列表
      fromData: {
        handlerId: "",
        accessoryInfoList: [],
      },
      editHoldListDialog: false,
      formConfig: {
        props: [
          {
            type: "input",
            name: "partsName",
            label: this.$lange == "en" ? "Description" : "物料名称",
            disabled: true,
          },
          {
            type: "radio",
            name: "wareAddress",
            label: this.$lange == "en" ? "Warehouse" : "仓库",
            options: [
              { val: "fsWarehouse", label: "佛山" },
              { val: "tjWarehouse", label: "天津" },
              { val: "shWarehouse", label: "上海" },
              { val: "cdWarehouse", label: "成都" },
              { val: "consignmentSale", label: "寄售" },
            ],
          },
          {
            type: "number",
            name: "partsNum",
            label: this.$lange == "en" ? "Quantity" : "数量",
          },

          {
            type: "radio",
            name: "feeType",
            label: this.$lange == "en" ? "Cost Type" : "费用类型",
            disabled: false,
            options: [
              { val: 0, label: this.$lange == "en" ? "Free" : "保内" },
              { val: 1, label: this.$lange == "en" ? "Paid" : "保外" },
            ],
          },
        ],
      },
      editorData: {},
      editorIndex: -1,
      rules: {
        partsName: [
          {
            required: true,
            message: "物料名称不可为空",
            trigger: "blur",
          },
        ],
        wareAddress: [
          {
            required: true,
            message: "仓库不可为空",
            trigger: "blur",
          },
        ],
        partsNum: [
          {
            required: true,
            message: "数量不可为空",
            trigger: "blur",
          },
        ],
        fasCode: [
          {
            required: true,
            message: "FAS料号不可为空",
            trigger: "blur",
          },
        ],
        // fiCode: [
        //   {
        //     required: true,
        //     message: "FI Code不可为空",
        //     trigger: "blur",
        //   },
        // ],
        feeType: [
          {
            required: true,
            message: "费用类型不可为空",
            trigger: "blur",
          },
        ],
      },
      newHoldListDialog: false,
      newFormConfig: {
        props: [
          {
            name: "fasCode",
            label: this.$lange == "en" ? "FAS Code" : "FAS料号",
            type: "input",
          },
          {
            type: "input",
            name: "fiCode",
            label: "FI Code",
          },

          {
            type: "input",
            name: "partsName",
            label: this.$lange == "en" ? "Description" : "物料名称",
          },
          // {
          //   type: "input",
          //   name: "wareAddress",
          //   label: "仓库",
          // },
          {
            type: "radio",
            name: "wareAddress",
            label: this.$lange == "en" ? "Warehouse" : "仓库",
            options: [
              { val: "fsWarehouse", label: "佛山" },
              { val: "tjWarehouse", label: "天津" },
              { val: "shWarehouse", label: "上海" },
              { val: "cdWarehouse", label: "成都" },
              { val: "consignmentSale", label: "寄售" },
            ],
          },
          {
            type: "number",
            name: "partsNum",
            label: this.$lange == "en" ? "Quantity" : "数量",
          },

          {
            type: "radio",
            name: "feeType",
            label: this.$lange == "en" ? "Cost Type" : "费用类型",
            disabled: false,
            options: [
              { val: 0, label: this.$lange == "en" ? "Free" : "保内" },
              { val: 1, label: this.$lange == "en" ? "Paid" : "保外" },
            ],
          },
        ],
      },
      newFormData: {},
      uploaderConf2: this.$uploadUtils.config, //文件上传需要
      openUploaderDialog: false,
    };
  },
  watch: {
    orderData: {
      handler() {
        console.log(this.orderData,'this.orderData')
        if (
          this.orderData.draftPartsOrder &&
          this.orderData.draftPartsOrder.partsOrderLogList.length > 0
        ) {
          this.holdList = this.orderData.draftPartsOrder.partsOrderLogList;
          if (this.orderData.draftPartsOrder.id) {
            this.fromData = {
              id: this.orderData.draftPartsOrder.id,
            };
          }
        }
        // this.fromData.handlerId = this.orderData.draftPartsOrder.handlerId * 1;
        if (this.orderData.draftPartsOrder) {
          this.fromData.accessoryInfoList =
            this.orderData.draftPartsOrder.accessoryInfoList;
        }
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    setWareAddressNum(data) {
      this.formConfig.props[1].options = [
        { val: "fsWarehouse", label:   `佛山(${data.fsWarehouse})`},
        { val: "tjWarehouse", label: `天津(${data.tjWarehouse})` },
        { val: "shWarehouse", label:   `上海(${data.shWarehouse})` },
        { val: "cdWarehouse", label: `成都(${data.cdWarehouse})` },
        { val: "consignmentSale", label: `寄售(${data.consignmentSale})` },
      ];
    },
    getUserList() {
      let api = `admin/fsb/work/order/queryHandlerUser?pageSize=999&isAsc=true`;
      this.ccRequest
        .do(api, ["accessoriesSpecialist"], "POSTJSON")
        .then((res) => {
          this.userSelectorList = res;
          if (this.fromData.handlerId == "") {
            this.fromData.handlerId = res[0].id;
          }
        });
    },
    showImage(url) {
      this.nowShowImageUrl = url;
      this.showImageFlag = true;
    },
    openAddPartsFlag() {
      this.editorIndex = -1;
      this.addPartsFlag = true;
      this.addPartsTableParams = {};
      this.newFormData = {};
      this.editorData = {};
      this.title1 = ["Spare Part List", "添加配件"];
    },
    openNewHoldListDialog() {
      this.editorIndex = -1;
      this.newHoldListDialog = true;
      this.newFormData = {};
      this.title2 = ["New code", "添加新料号"];
    },
    editorDataSave() {
      this.$refs["editForm"]
        .validate()
        .then(() => {
          let holdList = [...this.holdList];
          //编辑
          if (this.editorIndex > -1) {
            holdList[this.editorIndex] = {};
            holdList[this.editorIndex] = { ...this.editorData };
          } else {
            //新增
            holdList.push(this.editorData);
          }
          this.holdList = holdList;
          this.editHoldListDialog = false;
          console.log(this.holdList, this.editorData);
          // console.log(this.editorIndex)
        })
        .catch(() => {});
    },
    newFormDataSave() {
      this.$refs["newFormData"]
        .validate()
        .then(() => {
          let data = {
            ...this.newFormData,
            jobId: this.orderData.jobId,
            remark: "新添加配件",
            parts: {
              status: 0,
              ...this.newFormData,
              remark: "新添加配件",
            },
            relPrice: "",
            discount: "",
            salePrice: "",
          };
          let holdList = [...this.holdList];
          //修改
          if (this.editorIndex > -1) {
            holdList[this.editorIndex] = {};
            holdList[this.editorIndex] = { ...data };
          } else {
            //新增
            holdList.push(data);
          }
          this.holdList = holdList;
          console.log(data);
          this.newHoldListDialog = false;
          this.addPartsFlag = false;
        })
        .catch(() => {});
    },
    uploadTrue(res) {
      console.log(res, "uploadTrue");
      this.fromData.accessoryInfoList.push(res);
      this.$message({
        type: "success",
        message: "上传成功",
      });
      this.openUploaderDialog = false;
    },
    deleteImage(idx) {
      this.fromData.accessoryInfoList.splice(idx, 1);
    },
    save(status) {
      if (!this.fromData.handlerId) {
        this.$message.error("请选择处理人");
        return false;
      } else if (this.holdList.length == 0) {
        this.$message.error("请添加配件");
        return false;
      }
      //1提交  0暂存
      let form = {
        status: status,
        workOrderId: this.orderData.id,
        handlerId: this.fromData.handlerId,
        accessoryInfoList: [...this.fromData.accessoryInfoList],
        partsOrderLogList: [...this.holdList],
        id: this.fromData.id,
      };

      console.log(this.orderData, form);
      // return false;
      this.$confirm("确定提交吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.ccRequest
            .do("admin/fsb/work/order/log/savePartsOrder", form, "POSTJSON")
            .then((res) => {
              if (status == 1) {
                this.fromData.accessoryInfoList = [];
                this.fromData.id = "";
                this.holdList = [];
                this.fromData.handlerId = "";
                this.listTablereferTableConfig = new Date().getTime();
              } else {
                // this.$emit("updateOrder", [
                //   "draftPartsOrder",
                //   "remarkList",
                //   "countPartsOrder",
                //   "isHandle",
                // ]);
              }
              this.$emit("updateOrder", true);
              this.$message({
                type: "success",
                message: "操作成功",
              });
            })
            .catch((err) => {
              this.$message.error(err.response.data.message);
            });
        })
        .catch((err) => {
          this.$message.error(err.response.data.message);
        });
    },
    saveHold(status) {
      if (!this.fromData.handlerId) {
        this.$message.error("请选择处理人");
        return false;
      } else if (this.holdList.length == 0) {
        this.$message.error("请添加配件");
        return false;
      }
      //1提交  0暂存
      let form = {
        status: status,
        workOrderId: this.orderData.id,
        handlerId: this.fromData.handlerId,
        accessoryInfoList: [...this.fromData.accessoryInfoList],
        partsOrderLogList: [...this.holdList],
        id: this.fromData.id,
      };

      console.log(this.orderData, form);
      // return false;
      // this.$confirm("确定提交吗？", "提示", {
      //   confirmButtonText: "确定",
      //   cancelButtonText: "取消",
      //   type: "warning",
      // })
      //   .then(() => {
      // return false
      this.ccRequest
        .do("admin/fsb/work/order/log/savePartsOrder", form, "POSTJSON")
        .then((res) => {
          if (status == 1) {
            this.fromData.accessoryInfoList = [];
            this.holdList = [];
            this.fromData.handlerId = "";
            this.listTablereferTableConfig = new Date().getTime();
          } else {
            this.$emit("updateOrder", [
              "draftPartsOrder",
              "remarkList",
              "countPartsOrder",
              "isHandle",
            ]);
          }
          this.$message({
            type: "success",
            message: "操作成功",
          });
        })
        .catch((err) => {
          this.$message.error(err.response.data.message);
        });
      // })
      // .catch((err) => {
      //   this.$message.error(err.response.data.message);
      // });
    },
  },
  mounted() {
    this.getUserList();
  },
};
</script>
<style scoped lang="scss">
.order-solution {
  background: #ffffff;
  margin-top: 5px;

  .os-list {
    padding: 20px;
    border-bottom: 10px solid #f3f3f4;

    // border-bottom: 1px dotted #ccc;
    // border-top: 5px solid #f3f3f4;
    .os-title {
      .left {
        justify-content: flex-start;

        > * {
          margin-left: 80px;
        }

        .title-control {
          padding: 0px;
          border-radius: 5px;
          border: 1px solid #e4e4e4;
          width: 24px;
          height: 24px;
          justify-content: center;
          font-size: 20px;
          cursor: pointer;
          margin-left: 0;
          & ~ .title {
            font-weight: bolder;
            color: #6f6f6f;
            width: 200px;
          }
        }

        .title {
          font-size: 18px;
          margin-left: 20px;
        }
      }
    }
  }
}
.li_wrap {
  margin-top: 20px;
  .li {
    margin-bottom: 20px;
  }
}

.wrap {
  .card {
    margin-top: 20px;
    padding: 30px 20px 20px 20px;
    background: rgb(245, 247, 250);
  }
  .add_title {
    display: flex;
    justify-content: space-between;
    margin-bottom: 10px;
    .title {
      font-size: 16px;
      font-weight: bold;
    }
    span {
      margin-right: 20px;
    }
    .user_select {
      display: flex;
      align-items: center;
      // width: 270px;
      width: 220px;
      span {
        min-width: 70px;
        margin-right: 0px;
      }
    }
    .user_select2 {
      width: 240px;
      span {
        min-width: 90px;
      }
    }
  }
  .new_wrap {
    display: flex;
    justify-content: space-between;
    .new_wrap_left {
      width: 100%;
      margin-right: 20px;
      .table {
        // max-width: 700px;
        width: 80%;
      }
    }
    .new_wrap_right {
      // min-width: 200px;
      min-width: 150px;
      .new_wrap_right_button {
        position: relative;
        width: 100%;
        margin-bottom: 10px;
        display: flex;
        align-items: center;
        font-weight: bold;
        span {
          min-width: 70px;
        }
      }
      .uploaderConf2 {
        position: absolute;
        left: 0px;
        top: 0px;
        height: 100%;
        width: 100%;
        opacity: 0;
      }
    }
  }
  .file {
    margin-top: 20px;
    display: flex;
    padding-bottom: 30px;
  }
  .file_img {
    display: flex;
    .img_list {
      position: relative;
    }
    .img {
      width: 50px;
      height: 50px;
      margin: 0 10px;
    }
    .del-image {
      width: 20px;
      height: 20px;
      line-height: 0;
      justify-content: center;
      position: absolute;
      right: 0;
      top: 0;
      border: 1px solid #f00;
      color: #f00;
      font-size: 14px;
      border-radius: 50%;
      transform: translateX(0%) translateY(-50%);
      cursor: pointer;
    }
  }
  .order_mountings_list_wrap {
    .order_mountings_list_card {
      background: #fff;
      .title {
        font-size: 16px;
        font-weight: bold;
      }
    }
  }
}
.uploader {
  position: relative;
  height: 200px;
}
</style>
<style lang="scss">
.order_mountings_list_card {
  background: #fff;
  .clearfix {
    font-size: 16px;
    font-weight: bold;
  }
}
.image-slot {
  width: 100%;
  height: 100%;
  background: #dbdddf;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style> 